import { Route, Routes } from "react-router-dom";
import HomePage from "./pages/home/Home";
import Game from "./pages/game/Game";
import Multiplayer from "./pages/multiplayer/Multiplayer";
import SinglePlayer from "./pages/singleplayer/SinglePlayer";
import { ThemeProvider } from "styled-components";
import { useContext } from "react";
import { ThemeContext, UserContext } from "./global";
import ChangePassword from "./components/profilemodal/ChangePassword";
import DeleteUser from "./components/profilemodal/DeleteUser";
import { isMobile, isMobileSafari } from "react-device-detect";
import Analytics from "./Analytics";
import { NotFound } from "./pages/NotFound";

function Main() {
  const theme = useContext(ThemeContext);
  const { user } = useContext(UserContext);

  return (
    <ThemeProvider theme={theme.myTheme.colors}>
      <Analytics />
      <div
        style={{
          backgroundColor: theme.myTheme.colors.background,
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Routes>
          <Route path="/" element={<HomePage isMobile={isMobile} />} />
          <Route
            path="/singleplayer"
            element={
              <SinglePlayer
                isMobile={isMobile}
                isMobileSafari={isMobileSafari}
              />
            }
          />
          <Route
            path="/multiplayer"
            element={
              <Multiplayer
                isMobile={isMobile}
                isMobileSafari={isMobileSafari}
              />
            }
          />
          <Route path="/game" element={<Game isMobile={isMobile} />} />
          <Route path="/change-password" element={<ChangePassword />} />
          {user.username && (
            <>
              <Route path="/delete-account" element={<DeleteUser />} />
            </>
          )}

          {/* 404 route */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </ThemeProvider>
  );
}

export default Main;
